import { useQuery } from '@tanstack/react-query';
import { InvitationsApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useInvitationsControllerGetInvitationByIdQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['invitationsControllerGetInvitationById', accessControlScope, args],
        queryFn: async () => {
            const api = new InvitationsApi(accessControlConfig);
            return api.invitationsControllerGetInvitationById(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useInvitationsControllerGetInvitationByIdQuery.js.map